import React from 'react';

interface SessionTimeoutWarningProps {
  timeRemaining: number;
  onDismiss: () => void;
  onExtend?: () => void; // Keep for backward compatibility but unused
}

const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  timeRemaining,
  onDismiss
}) => {
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const isUrgent = timeRemaining <= 60;

  return (
    <div className="session-timeout-warning">
      <div className={`warning-container ${isUrgent ? 'urgent' : ''}`}>
        <div className="warning-icon">
          {isUrgent ? '🚨' : '⏰'}
        </div>
        <div className="warning-content">
          <h3 className="warning-title">
            {isUrgent ? 'Session Expiring Soon!' : 'Session Timeout Warning'}
          </h3>
          <p className="warning-message">
            Your session will expire in <strong>{formatTime(timeRemaining)}</strong> due to inactivity.
          </p>
          <p className="warning-submessage">
            {isUrgent 
              ? 'Please save your work immediately!' 
              : 'Please save your work. You will need to log in again after the session expires.'}
          </p>
        </div>
        <div className="warning-actions">
          <button 
            className="btn btn-primary"
            onClick={onDismiss}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;